import {
  Box,
  Container,
  Flex,
  Heading,
  SimpleGrid,
  Text,
  VStack
} from "@chakra-ui/react";
import type { ColDef, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useCallback, useEffect, useMemo, useState } from "react";

// Import AG Grid Enterprise and register modules
import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import {
  AllEnterpriseModule,
  IntegratedChartsModule
} from "ag-grid-enterprise";
import CustomerDetailModel from "../components/CustomerDetailModel";

// Register AG Grid modules including charts
ModuleRegistry.registerModules([
  AllCommunityModule,
  AllEnterpriseModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule)
]);

// Mock customer data
const mockCustomers = [
  {
    step: 11,
    stage: "CONGRATULATIONS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_700",
    emailAddress: "s.hassan.92@yahoo.com",
    firstName: "Samira",
    lastName: "Hassan",
    homeType: ["DETACHED"],
    currentStage: "JUST_GETTING_STARTED",
    phoneNumber: "+14165558921",
    referralSource: "FACEBOOK",
    timeframe: "THREE_TO_SIX_MONTHS",
    totalIncome: 9000000,
    totalSavings: 5000000,
    affordability: 45500000,
    zownContribution: 682500,
    qualificationStatus: "QUALIFIED",
    zid: "951dccd4-c4d1-423a-91aa-d968c34f4a42",
    zvid: "250125042911",
    vid: "250125042911",
    zcid: "250320170841834",
    cid: "250320170841834",
    bid: "97934089-5278-4127-8cdd-a7f84c068e5a"
  },
  {
    step: 8,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "650_TO_700",
    emailAddress: "mthompson47@gmail.com",
    firstName: "Marcus",
    lastName: "Thompson",
    homeType: ["CONDO"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+16475552847",
    referralSource: "GOOGLE",
    timeframe: "ONE_TO_THREE_MONTHS",
    totalIncome: 7500000,
    totalSavings: 3000000,
    affordability: 35000000,
    zownContribution: 525000,
    qualificationStatus: "PENDING",
    zid: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    zvid: "250125042912",
    vid: "250125042912",
    zcid: "250320170841835",
    cid: "250320170841835",
    bid: "12345678-9abc-def0-1234-56789abcdef0"
  },
  {
    step: 15,
    stage: "COMPLETED",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_750",
    emailAddress: "bella_martinez88@outlook.com",
    firstName: "Isabella",
    lastName: "Martinez",
    homeType: ["TOWNHOUSE"],
    currentStage: "READY_TO_BUY",
    phoneNumber: "+14165553692",
    referralSource: "INSTAGRAM",
    timeframe: "IMMEDIATELY",
    totalIncome: 12000000,
    totalSavings: 8000000,
    affordability: 65000000,
    zownContribution: 975000,
    qualificationStatus: "QUALIFIED",
    zid: "xyz789-abc-def1-2345-6789abcdef12",
    zvid: "250125042913",
    vid: "250125042913",
    zcid: "250320170841836",
    cid: "250320170841836",
    bid: "fedcba98-7654-3210-fedc-ba9876543210"
  },
  {
    step: 5,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "600_TO_650",
    emailAddress: "nwong2024@hotmail.com",
    firstName: "Nathan",
    lastName: "Wong",
    homeType: ["DETACHED"],
    currentStage: "RESEARCHING",
    phoneNumber: "+16475554153",
    referralSource: "GOOGLE",
    timeframe: "SIX_MONTHS_TO_ONE_YEAR",
    totalIncome: 6000000,
    totalSavings: 2500000,
    affordability: 30000000,
    zownContribution: 450000,
    qualificationStatus: "PENDING",
    zid: "michael-123-456-789",
    zvid: "250125042914",
    vid: "250125042914",
    zcid: "250320170841837",
    cid: "250320170841837",
    bid: "michael-bid-123-456"
  },
  {
    step: 12,
    stage: "CONGRATULATIONS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_750",
    emailAddress: "priyasharma.home@gmail.com",
    firstName: "Priya",
    lastName: "Sharma",
    homeType: ["CONDO"],
    currentStage: "READY_TO_BUY",
    phoneNumber: "+14165557829",
    referralSource: "FACEBOOK",
    timeframe: "IMMEDIATELY",
    totalIncome: 11000000,
    totalSavings: 7000000,
    affordability: 55000000,
    zownContribution: 825000,
    qualificationStatus: "QUALIFIED",
    zid: "emma-789-012-345",
    zvid: "250125042915",
    vid: "250125042915",
    zcid: "250320170841838",
    cid: "250320170841838",
    bid: "emma-bid-789-012"
  },
  {
    step: 3,
    stage: "STARTED",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "BELOW_600",
    emailAddress: "t_anderson_23@yahoo.com",
    firstName: "Taylor",
    lastName: "Anderson",
    homeType: ["TOWNHOUSE"],
    currentStage: "EXPLORING_OPTIONS",
    phoneNumber: "+16475556284",
    referralSource: "INSTAGRAM",
    timeframe: "MORE_THAN_ONE_YEAR",
    totalIncome: 4500000,
    totalSavings: 1500000,
    affordability: 22000000,
    zownContribution: 330000,
    qualificationStatus: "NOT_QUALIFIED",
    zid: "alex-345-678-901",
    zvid: "250125042916",
    vid: "250125042916",
    zcid: "250320170841839",
    cid: "250320170841839",
    bid: "alex-bid-345-678"
  },
  {
    step: 9,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "700_TO_750",
    emailAddress: "oliviabennett.realty@outlook.com",
    firstName: "Olivia",
    lastName: "Bennett",
    homeType: ["DETACHED"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+14165559431",
    referralSource: "GOOGLE",
    timeframe: "ONE_TO_THREE_MONTHS",
    totalIncome: 8500000,
    totalSavings: 4500000,
    affordability: 42000000,
    zownContribution: 630000,
    qualificationStatus: "QUALIFIED",
    zid: "lisa-567-890-123",
    zvid: "250125042917",
    vid: "250125042917",
    zcid: "250320170841840",
    cid: "250320170841840",
    bid: "lisa-bid-567-890"
  },
  {
    step: 7,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_700",
    emailAddress: "jamesbourikos@gmail.com",
    firstName: "James",
    lastName: "Bourikos",
    homeType: ["CONDO"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+14167057733",
    referralSource: "GOOGLE",
    timeframe: "THREE_TO_SIX_MONTHS",
    totalIncome: 8200000,
    totalSavings: 3800000,
    affordability: 38000000,
    zownContribution: 570000,
    qualificationStatus: "QUALIFIED",
    zid: "james-bid-001-234",
    zvid: "250125042918",
    vid: "250125042918",
    zcid: "250320170841841",
    cid: "250320170841841",
    bid: "james-bid-001-234"
  },
  {
    step: 4,
    stage: "STARTED",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "650_TO_700",
    emailAddress: "jdpokeadot@gmail.com",
    firstName: "Hahhs",
    lastName: "Bsbsh",
    homeType: ["TOWNHOUSE"],
    currentStage: "EXPLORING_OPTIONS",
    phoneNumber: "+12896837333",
    referralSource: "GOOGLE",
    timeframe: "SIX_MONTHS_TO_ONE_YEAR",
    totalIncome: 5800000,
    totalSavings: 2200000,
    affordability: 28000000,
    zownContribution: 420000,
    qualificationStatus: "PENDING",
    zid: "hahhs-bid-002-345",
    zvid: "250125042919",
    vid: "250125042919",
    zcid: "250320170841842",
    cid: "250320170841842",
    bid: "hahhs-bid-002-345"
  },
  {
    step: 10,
    stage: "CONGRATULATIONS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_750",
    emailAddress: "brunobragasurf@gmail.com",
    firstName: "Bruno",
    lastName: "Braga",
    homeType: ["DETACHED"],
    currentStage: "READY_TO_BUY",
    phoneNumber: "+16477172600",
    referralSource: "GOOGLE",
    timeframe: "IMMEDIATELY",
    totalIncome: 10500000,
    totalSavings: 6500000,
    affordability: 52000000,
    zownContribution: 780000,
    qualificationStatus: "QUALIFIED",
    zid: "bruno-bid-003-456",
    zvid: "250125042920",
    vid: "250125042920",
    zcid: "250320170841843",
    cid: "250320170841843",
    bid: "bruno-bid-003-456"
  },
  {
    step: 6,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "700_TO_750",
    emailAddress: "kenechieze2@gmail.com",
    firstName: "Kenechi",
    lastName: "Eze",
    homeType: ["CONDO"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+12269297076",
    referralSource: "FACEBOOK",
    timeframe: "ONE_TO_THREE_MONTHS",
    totalIncome: 7800000,
    totalSavings: 3500000,
    affordability: 37000000,
    zownContribution: 555000,
    qualificationStatus: "QUALIFIED",
    zid: "kenechi-bid-004-567",
    zvid: "250125042921",
    vid: "250125042921",
    zcid: "250320170841844",
    cid: "250320170841844",
    bid: "kenechi-bid-004-567"
  },
  {
    step: 5,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "650_TO_700",
    emailAddress: "john123455551234@gmail.com",
    firstName: "John",
    lastName: "Smith",
    homeType: ["TOWNHOUSE"],
    currentStage: "RESEARCHING",
    phoneNumber: "+16475258712",
    referralSource: "GOOGLE",
    timeframe: "THREE_TO_SIX_MONTHS",
    totalIncome: 6500000,
    totalSavings: 2800000,
    affordability: 31000000,
    zownContribution: 465000,
    qualificationStatus: "PENDING",
    zid: "john-bid-005-678",
    zvid: "250125042922",
    vid: "250125042922",
    zcid: "250320170841845",
    cid: "250320170841845",
    bid: "john-bid-005-678"
  },
  {
    step: 11,
    stage: "CONGRATULATIONS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_750",
    emailAddress: "zac.weinberger@outlook.com",
    firstName: "Zac",
    lastName: "Weinberger",
    homeType: ["DETACHED"],
    currentStage: "READY_TO_BUY",
    phoneNumber: "+12263770615",
    referralSource: "FACEBOOK",
    timeframe: "IMMEDIATELY",
    totalIncome: 11500000,
    totalSavings: 7500000,
    affordability: 58000000,
    zownContribution: 870000,
    qualificationStatus: "QUALIFIED",
    zid: "zac-bid-006-789",
    zvid: "250125042923",
    vid: "250125042923",
    zcid: "250320170841846",
    cid: "250320170841846",
    bid: "zac-bid-006-789"
  },
  {
    step: 6,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "700_TO_750",
    emailAddress: "drumisales@gmail.com",
    firstName: "Andrew",
    lastName: "Drumm",
    homeType: ["CONDO"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+14165531314",
    referralSource: "FACEBOOK",
    timeframe: "ONE_TO_THREE_MONTHS",
    totalIncome: 7200000,
    totalSavings: 3200000,
    affordability: 35000000,
    zownContribution: 525000,
    qualificationStatus: "PENDING",
    zid: "andrew-bid-007-890",
    zvid: "250125042924",
    vid: "250125042924",
    zcid: "250320170841847",
    cid: "250320170841847",
    bid: "andrew-bid-007-890"
  },
  {
    step: 12,
    stage: "CONGRATULATIONS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_750",
    emailAddress: "karli.ttyll@gmail.com",
    firstName: "Carli",
    lastName: "Reardon",
    homeType: ["TOWNHOUSE"],
    currentStage: "READY_TO_BUY",
    phoneNumber: "+16138598073",
    referralSource: "INSTAGRAM",
    timeframe: "IMMEDIATELY",
    totalIncome: 10200000,
    totalSavings: 6200000,
    affordability: 51000000,
    zownContribution: 765000,
    qualificationStatus: "QUALIFIED",
    zid: "carli-bid-008-901",
    zvid: "250125042925",
    vid: "250125042925",
    zcid: "250320170841848",
    cid: "250320170841848",
    bid: "carli-bid-008-901"
  },
  {
    step: 8,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_700",
    emailAddress: "slymoments@gmail.com",
    firstName: "Unysiah",
    lastName: "Morris",
    homeType: ["CONDO"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+16477177292",
    referralSource: "FACEBOOK",
    timeframe: "THREE_TO_SIX_MONTHS",
    totalIncome: 8800000,
    totalSavings: 4200000,
    affordability: 42000000,
    zownContribution: 630000,
    qualificationStatus: "QUALIFIED",
    zid: "unysiah-bid-009-012",
    zvid: "250125042926",
    vid: "250125042926",
    zcid: "250320170841849",
    cid: "250320170841849",
    bid: "unysiah-bid-009-012"
  },
  {
    step: 5,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "650_TO_700",
    emailAddress: "jaynishp@ymail.com",
    firstName: "Jaynish",
    lastName: "Patel",
    homeType: ["DETACHED"],
    currentStage: "RESEARCHING",
    phoneNumber: "+16475713314",
    referralSource: "GOOGLE",
    timeframe: "SIX_MONTHS_TO_ONE_YEAR",
    totalIncome: 6800000,
    totalSavings: 2900000,
    affordability: 32000000,
    zownContribution: 480000,
    qualificationStatus: "PENDING",
    zid: "jaynish-bid-010-123",
    zvid: "250125042927",
    vid: "250125042927",
    zcid: "250320170841850",
    cid: "250320170841850",
    bid: "jaynish-bid-010-123"
  },
  {
    step: 9,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "700_TO_750",
    emailAddress: "smaysantos@gmail.com",
    firstName: "Sunshine",
    lastName: "Santos",
    homeType: ["CONDO"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+16479789843",
    referralSource: "FACEBOOK",
    timeframe: "ONE_TO_THREE_MONTHS",
    totalIncome: 8000000,
    totalSavings: 3700000,
    affordability: 38000000,
    zownContribution: 570000,
    qualificationStatus: "QUALIFIED",
    zid: "sunshine-bid-011-234",
    zvid: "250125042928",
    vid: "250125042928",
    zcid: "250320170841851",
    cid: "250320170841851",
    bid: "sunshine-bid-011-234"
  },
  {
    step: 7,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "ABOVE_700",
    emailAddress: "burkie44@live.ca",
    firstName: "Callum",
    lastName: "Burke",
    homeType: ["TOWNHOUSE"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+16479751393",
    referralSource: "FACEBOOK",
    timeframe: "THREE_TO_SIX_MONTHS",
    totalIncome: 7600000,
    totalSavings: 3400000,
    affordability: 36000000,
    zownContribution: 540000,
    qualificationStatus: "QUALIFIED",
    zid: "callum-bid-012-345",
    zvid: "250125042929",
    vid: "250125042929",
    zcid: "250320170841852",
    cid: "250320170841852",
    bid: "callum-bid-012-345"
  },
  {
    step: 8,
    stage: "IN_PROGRESS",
    formId: "ZownCABuyerQualifyContactForm",
    creditScore: "700_TO_750",
    emailAddress: "thechappilly@gmail.com",
    firstName: "Thomas",
    lastName: "Paul",
    homeType: ["DETACHED"],
    currentStage: "ACTIVELY_SEARCHING",
    phoneNumber: "+16477049439",
    referralSource: "FACEBOOK",
    timeframe: "ONE_TO_THREE_MONTHS",
    totalIncome: 8400000,
    totalSavings: 4000000,
    affordability: 40000000,
    zownContribution: 600000,
    qualificationStatus: "QUALIFIED",
    zid: "thomas-bid-013-456",
    zvid: "250125042930",
    vid: "250125042930",
    zcid: "250320170841853",
    cid: "250320170841853",
    bid: "thomas-bid-013-456"
  }
];

function Customers() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  // Fix for Leaflet default markers in React
  useEffect(() => {
    delete (L.Icon.Default.prototype as any)._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
      iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png"
    });
  }, []);

  // Handle customer row click
  const handleCustomerRowClick = useCallback((customer: any) => {
    setSelectedCustomer(customer);
    setIsModalOpen(true);
  }, []);

  // Helper function to format money (cents to dollars)
  const formatMoney = (cents: number) => {
    return `$${(cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  // Note: Status and stage color functions removed as they're no longer needed with valueFormatter

  // AG Grid column definitions for customers
  const customerColumnDefs: ColDef[] = useMemo(
    () => [
      {
        headerName: "Name",
        field: "firstName",
        filter: "agTextColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 150,
        maxWidth: 200,
        valueFormatter: (params: any) => {
          const customer = params.data;
          return `${customer.firstName} ${customer.lastName} (Step ${customer.step})`;
        }
      },
      {
        headerName: "Email",
        field: "emailAddress",
        filter: "agTextColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 180,
        maxWidth: 220,
        valueFormatter: (params: any) => {
          return params.value || "";
        }
      },
      {
        headerName: "Phone",
        field: "phoneNumber",
        filter: "agTextColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 140,
        maxWidth: 180,
        valueFormatter: (params: any) => {
          return params.value || "";
        }
      },
      {
        headerName: "Status",
        field: "qualificationStatus",
        filter: "agSetColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 130,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          const customer = params.data;
          const stage = customer.stage ? customer.stage.replace(/_/g, " ") : "";
          return `${customer.qualificationStatus} / ${stage}`;
        }
      },
      {
        headerName: "Credit Score",
        field: "creditScore",
        filter: "agSetColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          return params.value ? params.value.replace(/_/g, " ") : "N/A";
        }
      },
      {
        headerName: "Income",
        field: "totalIncome",
        filter: "agNumberColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          return params.value ? formatMoney(params.value) : "N/A";
        }
      },
      {
        headerName: "Savings",
        field: "totalSavings",
        filter: "agNumberColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          return params.value ? formatMoney(params.value) : "N/A";
        }
      },
      {
        headerName: "Affordability",
        field: "affordability",
        filter: "agNumberColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 130,
        maxWidth: 160,
        valueFormatter: (params: any) => {
          return params.value ? formatMoney(params.value) : "N/A";
        }
      },
      {
        headerName: "Contribution",
        field: "zownContribution",
        filter: "agNumberColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          return params.value ? formatMoney(params.value) : "N/A";
        }
      },
      {
        headerName: "Referral Source",
        field: "referralSource",
        filter: "agSetColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          return params.value || "";
        }
      },
      {
        headerName: "Home Type",
        field: "homeType",
        filter: "agSetColumnFilter",
        sortable: true,
        resizable: true,
        minWidth: 120,
        maxWidth: 150,
        valueFormatter: (params: any) => {
          const homeTypes = Array.isArray(params.value)
            ? params.value
            : [params.value];
          return homeTypes.join(", ");
        }
      }
    ],
    [formatMoney]
  );

  // Default column definition
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      suppressSizeToFit: true,
      autoHeaderHeight: true
    }),
    []
  );

  // Grid ready event
  const onGridReady = useCallback((event: GridReadyEvent) => {
    // Auto-size all columns based on content
    event.api.autoSizeAllColumns();
  }, []);

  return (
    <Container maxW="7xl" py={8}>
      {/* Header */}
      <Flex justify="space-between" align="center" mb={8}>
        <VStack align="start" gap={2}>
          <Heading size="2xl" color="#191d16">
            Customers
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Every connection. Every possibility.
          </Text>
        </VStack>
      </Flex>

      <Box h="1px" bg="gray.200" mb={8} />

      {/* Customer Statistics */}
      <SimpleGrid columns={{ base: 2, md: 4 }} gap={6} mb={8}>
        <Box
          bg="white"
          p={6}
          rounded="lg"
          shadow="md"
          border="1px"
          borderColor="gray.200"
          textAlign="center"
        >
          <Text fontSize="2xl" fontWeight="bold" color="blue.600" mb={1}>
            {mockCustomers.length}
          </Text>
          <Text fontSize="sm" color="gray.600">
            Total Customers
          </Text>
        </Box>

        <Box
          bg="white"
          p={6}
          rounded="lg"
          shadow="md"
          border="1px"
          borderColor="gray.200"
          textAlign="center"
        >
          <Text fontSize="2xl" fontWeight="bold" color="green.600" mb={1}>
            {
              mockCustomers.filter((c) => c.qualificationStatus === "QUALIFIED")
                .length
            }
          </Text>
          <Text fontSize="sm" color="gray.600">
            Qualified
          </Text>
        </Box>

        <Box
          bg="white"
          p={6}
          rounded="lg"
          shadow="md"
          border="1px"
          borderColor="gray.200"
          textAlign="center"
        >
          <Text fontSize="2xl" fontWeight="bold" color="orange.600" mb={1}>
            {
              mockCustomers.filter((c) => c.qualificationStatus === "PENDING")
                .length
            }
          </Text>
          <Text fontSize="sm" color="gray.600">
            Pending
          </Text>
        </Box>

        <Box
          bg="white"
          p={6}
          rounded="lg"
          shadow="md"
          border="1px"
          borderColor="gray.200"
          textAlign="center"
        >
          <Text fontSize="2xl" fontWeight="bold" color="purple.600" mb={1}>
            {formatMoney(
              mockCustomers
                .filter(
                  (c) =>
                    c.stage === "CONGRATULATIONS" || c.stage === "COMPLETED"
                )
                .reduce(
                  (sum, customer) => sum + (customer.zownContribution || 0),
                  0
                )
            )}
          </Text>
          <Text fontSize="sm" color="gray.600">
            Total Revenue
          </Text>
        </Box>
      </SimpleGrid>

      {/* Customers Table */}
      <Box
        bg="white"
        rounded="lg"
        shadow="md"
        overflow="hidden"
        border="1px solid"
        borderColor="gray.200"
        mb={8}
      >
        <Box p={4} borderBottom="1px" borderColor="gray.200">
          <Heading size="md" color="#191d16">
            Customer Database ({mockCustomers.length})
          </Heading>
          <Text fontSize="sm" color="gray.600" mt={1}>
            Click on any customer to view detailed information
          </Text>
        </Box>
        <Box height="600px" width="100%">
          <AgGridReact
            rowData={mockCustomers}
            columnDefs={customerColumnDefs}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            onRowClicked={(event) => handleCustomerRowClick(event.data)}
            onFirstDataRendered={(params) => {
              // Auto-size columns when data is first rendered
              params.api.autoSizeAllColumns();
            }}
            onGridSizeChanged={(params) => {
              // Auto-size columns when grid is resized
              params.api.autoSizeAllColumns();
            }}
            animateRows={true}
            cellSelection={true}
            enableCharts={true}
            sideBar={{
              toolPanels: [
                {
                  id: "columns",
                  labelDefault: "Columns",
                  labelKey: "columns",
                  iconKey: "columns",
                  toolPanel: "agColumnsToolPanel"
                },
                {
                  id: "filters",
                  labelDefault: "Filters",
                  labelKey: "filters",
                  iconKey: "filter",
                  toolPanel: "agFiltersToolPanel"
                }
              ],
              hiddenByDefault: true
            }}
            rowSelection={{
              mode: "singleRow",
              enableClickSelection: true
            }}
            pagination={true}
            paginationPageSize={20}
            paginationPageSizeSelector={[10, 20, 50, 100]}
            paginationAutoPageSize={false}
            suppressPaginationPanel={false}
            paginationNumberFormatter={(params) => {
              return params.value.toLocaleString();
            }}
            localeText={{
              page: "Page",
              more: "More",
              to: "to",
              of: "of",
              next: "Next",
              last: "Last",
              first: "First",
              previous: "Previous",
              loadingOoo: "Loading...",
              noRowsToShow: "No customers to show"
            }}
            rowHeight={60}
            loading={false}
          />
        </Box>
      </Box>

      {/* Customer Detail Modal */}
      <CustomerDetailModel
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        customer={selectedCustomer}
      />
    </Container>
  );
}

export default Customers;
